import { useEffect, useState, useRef } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import {
  useFetchAllBikajiOrdersMutation,
  useUpdateOrderStatusBikajiMutation,
  useFetchAllBikajiShelfMutation,
  useUpdateShelfStatusBikajiMutation,
  useExtractInvoiceFieldsMutation,
  useSaveExtractDataMutation,
} from "../../../features/tenant/Bikaji/BikajiApi";
import { getVendorName } from "../../../utils/getVendorName";
import toast from "react-hot-toast";
import { TiTick, TiTimes } from "react-icons/ti"
import { FiCheckCircle, FiXCircle , FiInfo} from "react-icons/fi";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
// import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import MediaModal from "../../../components/Tenant/MediaModal/MediaModal";
import view from "../../../assests/tenant/images/view.svg";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const BikajiOrderList = () => {
  const navigate = useNavigate();
  const [tableDataItems, setTableDataItems] = useState([]);
  const [myList, setMyList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [mediaUrl, setMediaUrl] = useState("");
  const [showMedia, setShowMedia] = useState(false);
  const [imgRotation, setImgRotation] = useState(0);
  const [rejectReason, setRejectReason] = useState("")
  const [isEditing, setIsEditing] = useState(false);
  // CATEGORY + MULTISELECT STATE
  // Default to "all" as you requested (All tab before Green)
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedRows, setSelectedRows] = useState([]); // persistent across tabs
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const initialRequest = {
    limit: 10,
    offset: 0,
    mobile: "",
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);

  const isPdf = (url) =>
   typeof url === "string" && url.toLowerCase().includes(".pdf");
  const getMediaUrl = (row) => {
    if (row?.invoice_pdf) return row.invoice_pdf;
    if (Array.isArray(row?.invoice_image) && row.invoice_image[0]) {
      return row.invoice_image[0];
    }
    return null;
  };

  //Modal state 
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showExtraction, setShowExtraction] = useState(false);
  const [extracted, setExtracted] = useState(null); // { for invoice_date, invoice_number, gstin, total_amount }
  const [alreadySaved, setAlreadySaved] = useState(false); // NEW: lock after save
  const urlForPreview = getMediaUrl(selectedRow);
  const isPdfFile = urlForPreview ? isPdf(urlForPreview) : false;



  // Uncontrolled editable inputs via refs
  const invoiceDateRef = useRef(null);
  const invoiceNumberRef = useRef(null);
  const gstinRef = useRef(null);
  const totalAmountRef = useRef(null);
  const buyerNameRef = useRef(null);
  const approveAmountRef = useRef(null); // for Approve
  const rejectReasonRef = useRef(null); // for Reject

  const clearFilters = () => {
    setRequest(initialRequest);
    handleBikajiOrdersList(initialRequest);
  };

  const [
    fetchAllBikajiOrders,
    {
      data: fetchAllBikajiOrdersData,
      error: fetchAllBikajiOrdersError,
      isLoading: fetchAllBikajiOrdersisLoading,
    },
  ] = useFetchAllBikajiOrdersMutation();

  const [
    fetchAllBikajiOrdersCSV,
    {
      data: fetchAllBikajiOrdersCSVData,
      error: fetchAllBikajiOrdersCSVError,
    },
  ] = useFetchAllBikajiOrdersMutation();

  const [
    handleAcceptRequest,
    { data: handleAcceptRequestData, error: handleAcceptRequestError },
  ] = useUpdateOrderStatusBikajiMutation();

  const [
    handleRejectRequest,
    { data: handleRejectRequestData, error: handleRejectRequestError },
  ] = useUpdateOrderStatusBikajiMutation();

  // NEW: extractor hook (trigger + result state)
  const [
    extractInvoiceFields,
    {
      data: extractInvoiceFieldsData,
      error: extractInvoiceFieldsError,
      isLoading: extractInvoiceFieldsLoading,
    },
  ] = useExtractInvoiceFieldsMutation();

  const [
    saveExtractData,
    { data: saveData, error: saveError, isLoading: saveLoading },
  ] = useSaveExtractDataMutation();


  const handleBikajiOrdersList = (orderRequest = request) => {
    fetchAllBikajiOrders({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: orderRequest,
    });
  };

  const handleBikajiOrdersListCSV = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    fetchAllBikajiOrdersCSV({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      token: sessionStorage.getItem("access_token"),
      body: modifiedRequest,
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (
      fetchAllBikajiOrdersCSVData &&
      fetchAllBikajiOrdersCSVData?.body?.orders
    ) {
      let tmpData = fetchAllBikajiOrdersCSVData?.body?.orders;
      tmpData = tmpData.map((item, index) => {
        return {
          ...item,
          remark: item.status == "1" ? "Approved" : item.status == "2" ? item.remark : "",
        };
      });
      setCsvData(tmpData);
    }

    if (fetchAllBikajiOrdersCSVError) {
      setCsvData(null);
    }
  }, [fetchAllBikajiOrdersCSVData, fetchAllBikajiOrdersCSVError]);

  useEffect(() => {
    handleBikajiOrdersList();
  }, [limit, offset]);

  // Map incoming orders -> add `category` from extract_data.confidence
  useEffect(() => {
    if (fetchAllBikajiOrdersData && fetchAllBikajiOrdersData.body) {
      toast.dismiss();
      toast.success(`${fetchAllBikajiOrdersData.message}`, {
        id: "fetchAllBikajiOrdersData",
      });
      const arr = [...fetchAllBikajiOrdersData.body.orders].map((order) => {
        try {
          const raw = order?.extract_data;
          const extract =
            raw && typeof raw === "string" ? JSON.parse(raw) : raw || null;

          if (extract?.confidence) {
            const conf = extract.confidence || {};
            const invoice_number = conf.invoice_number ?? 0;
            const invoice_date = conf.invoice_date ?? 0;
            const total_amount = conf.total_amount ?? 0;
            let category = "yellow";
            if (
              total_amount < 0.6 ||
              (invoice_number < 0.6 && invoice_date < 0.6)
            )
              category = "red";
            else if (
              invoice_number > 0.9 &&
              invoice_date > 0.9 &&
              total_amount > 0.9
            )
              category = "green";
            else if (total_amount >= 0.9)
              category = "yellow";
            else
              category = "yellow";
            return { ...order, category };
          }
          // If no extract_data, mark as red (requires review)
          return { ...order, category: "red" };
        } catch (e) {
          return { ...order, category: "red" };
        }
      });

      setTableDataItems(arr);

      setTotalRows(
        fetchAllBikajiOrdersData &&
          fetchAllBikajiOrdersData.body.total_orders
          ? fetchAllBikajiOrdersData.body.total_orders
          : 0
      );
    }

    if (fetchAllBikajiOrdersError) {
      toast.dismiss();
      toast.error(`${fetchAllBikajiOrdersError.data.message}`, {
        id: "fetchAllBikajiOrdersError",
      });
    }
  }, [fetchAllBikajiOrdersData, fetchAllBikajiOrdersError]);

  const handleApprove = (e, row) => {
    let amount = window.prompt("Please enter purchase amount (numbers only)");

    if (amount !== null) {
      amount = amount.trim();

      if (!/^\d+(\.\d+)?$/.test(amount)) {
        alert("❌ Please enter a valid number");
        return;
      }

      const numericAmount = Number(amount);

      handleAcceptRequest({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          order_line_id: row.order_line_id,
          status: "1",
          purchase_amount: numericAmount,
        },
      });
    }
  };

  useEffect(() => {
    if (handleAcceptRequestData) {
      toast.dismiss();
      toast.success(`${handleAcceptRequestData.message}`, {
        id: "handleAcceptRequestData",
      });
      handleBikajiOrdersList();
      setShowDetailModal(false);
    }

    if (handleAcceptRequestError) {
      toast.dismiss();
      toast.error(`${handleAcceptRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
    }
  }, [handleAcceptRequestData, handleAcceptRequestError]);

  const handleReject = (e, row) => {
    let reason = "";

    while (!reason || reason.trim() === "") {
      reason = window.prompt("Please enter reason");

      if (reason === null) {
        return;
      }
    }
    handleRejectRequest({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        order_line_id: row.order_line_id,
        status: "2",
        remark: reason,
      },
    });
  };

  useEffect(() => {
    if (handleRejectRequestData) {
      toast.dismiss();
      toast.success(`${handleRejectRequestData.message}`, {
        id: "handleRejectRequestData",
      });
      handleBikajiOrdersList(request);
      setShowDetailModal(false);
    }

    if (handleRejectRequestError) {
      toast.dismiss();
      toast.error(`${handleRejectRequestError.data.message}`, {
        id: "handleAcceptRequestError",
      });
    }
  }, [handleRejectRequestData, handleRejectRequestError]);

  const handleOpenMedia = (row) => {
  const url = getMediaUrl(row);
    if (!url) return;
    setMediaUrl(url);
    setShowMedia(true);
  };
  //Modal helpers

  const openDetailModal = (row) => {
    setSelectedRow(row);
    setShowDetailModal(true);
    setImgRotation(0);

    // reset extraction UI
    setShowExtraction(false);
    setExtracted(null);
    setAlreadySaved(false);

    // If this order already has extract_data on the row, use it locally.
    //    No API call here.
    try {
      const raw = row?.extract_data;
      if (raw) {
        const saved =
          typeof raw === "string" ? JSON.parse(raw) : raw;

        const f = saved?.fields || {};
        setExtracted({
          invoice_date: f.invoice_date ?? "",
          invoice_number: f.invoice_number ?? "",
          gstin: f.gstin ?? "",
          total_amount: f.total_amount ?? "",
          buyer_name: f.buyer_name ?? "",
          // In case we want to show category in modal immediately
          category: saved?.confidence?.category ?? row?.category ?? null,
        });

        setAlreadySaved(true);   // lock inputs & hide Extract
        setShowExtraction(true); // show fields section
      }
    } catch (e) {
      console.warn("Failed to parse extract_data on row:", e);
    }
  };



  // CALL Extract via RTK trigger (like orders)
  const handleExtract = () => {
    if (!selectedRow) return;

    const token = sessionStorage.getItem("access_token");
    const tenantIdFromSession =
      JSON.parse(sessionStorage.getItem("vendorData") || "{}").tenant_id;
    const tenant_id = tenantIdFromSession; // default 12 for now

    const order_id = selectedRow?.id;
    const url = getMediaUrl(selectedRow);

    if (!url || !order_id) {
      alert("Missing invoice URL or order id");
      return;
    }

    extractInvoiceFields({
      token,
      tenant_id,
      body: {
        order_id,
        url,
        // appUserId: selectedRow?.app_user_id || "user_42",
        tenantId: tenant_id,
        platform: "Dev",
      },
    });
  };

  // --- WHEN EXTRACTION COMPLETES ---
  useEffect(() => {
    if (extractInvoiceFieldsData && extractInvoiceFieldsData.body) {
      toast.dismiss();
      toast.success(`${extractInvoiceFieldsData.message}`, {
        id: "extractInvoiceFieldsData",
      });

      const body = extractInvoiceFieldsData.body;
      const f = body.fields || {};
      const conf = body.confidence || {};

      // === Compute category ===
      let category = "yellow";
      const invoice_number = conf.invoice_number ?? 0;
      const invoice_date = conf.invoice_date ?? 0;
      const total_amount = conf.total_amount ?? 0;
      if (total_amount < 0.75 || (invoice_number < 0.75 && invoice_date < 0.75))
        category = "red";
      else if (
        invoice_number > 0.9 &&
        invoice_date > 0.9 &&
        total_amount > 0.9
      )
        category = "green";
      else if (total_amount >= 0.9) category = "yellow";

      //  Show immediately in read-only mode
      setExtracted({
        invoice_date: f.invoice_date ?? "",
        invoice_number: f.invoice_number ?? "",
        gstin: f.gstin ?? "",
        total_amount: f.total_amount ?? "",
        buyer_name: f.buyer_name ?? "",
        category,
      });

      //  Mark as saved, lock editing
      setAlreadySaved(true);
      setIsEditing(false);
      setShowExtraction(true);

      //  Update selected row extract_data for instant UI reflection
      setSelectedRow((prev) => ({
        ...prev,
        extract_data: JSON.stringify({
          fields: f,
          confidence: conf,
          meta: body.meta || {},
        }),
      }));

      //  Refresh main list
      handleBikajiOrdersList();
    }

    if (extractInvoiceFieldsError) {
      const msg =
        extractInvoiceFieldsError?.data?.message ||
        extractInvoiceFieldsError?.error ||
        "Extract failed";
      toast.dismiss();
      toast.error(msg, { id: "extractInvoiceFieldsError" });
    }
  }, [extractInvoiceFieldsData, extractInvoiceFieldsError]);


  useEffect(() => {
    if (showDetailModal && approveAmountRef.current) {
      const amt = (extracted?.total_amount || "").toString();
      if (amt) {
        approveAmountRef.current.value = amt;
      }
    }
  }, [showDetailModal, extracted]);


  //SAVE extracted/edited fields (only when not yet saved)

  const handleSaveExtract = () => {
    if(!invoiceDateRef.current?.value)
    {
      alert("Invoice Date is required")
      return;
    }
    try {
      const token = sessionStorage.getItem("access_token");
      const tenantIdFromSession =
        JSON.parse(sessionStorage.getItem("vendorData") || "{}").tenant_id;
      const tenant_id = tenantIdFromSession || "12";
      const order_id = selectedRow?.id;

      const payload = {
        order_id,
        fields: {
          invoice_date: dayjs(invoiceDateRef.current?.value).format("YYYY-MM-DD") || dayjs().format("YYYY-MM-DD"),
          invoice_number: invoiceNumberRef.current?.value?.trim() || "",
          gstin: gstinRef.current?.value?.trim() || "",
          total_amount: totalAmountRef.current?.value?.trim() || "",
          buyer_name: buyerNameRef.current?.value?.trim() || "",
        },
      };

      saveExtractData({
        token,
        tenant_id,
        body: payload,
      });
    } catch (e) {
      alert(e.message || "Save failed");
    }
  };


  // Safe JSON parser for mixed extract_data (string/object)
  const safeParse = (data) => {
    if (!data) return {};
    if (typeof data === "object") return data; // already parsed
    try {
      return JSON.parse(data);
    } catch (e) {
      console.warn("Failed to parse extract_data:", e, data);
      return {};
    }
  };
  useEffect(() => {
    if (saveData) {
      toast.dismiss();
      toast.success(saveData.message || "Saved", { id: "saveExtractData" });

      // Extract new field values from API response
      const newFields = saveData?.body?.fields || saveData?.fields || {};

      //  Update extracted data shown in modal
      setExtracted((prev) => ({
        ...prev,
        ...newFields,
      }));

      //  Patch the selectedRow with updated extract_data
      setSelectedRow((prev) => {
        const prevData = safeParse(prev.extract_data);
        return {
          ...prev,
          extract_data: JSON.stringify({
            ...prevData,
            fields: {
              ...(prevData.fields || {}),
              ...newFields,
            },
          }),
        };
      });

      // Optional: Update main table instantly (no reload)
      setTableDataItems((prev) =>
        prev.map((row) => {
          if (row.id !== selectedRow.id) return row;
          const oldData = safeParse(row.extract_data);
          return {
            ...row,
            extract_data: JSON.stringify({
              ...oldData,
              fields: {
                ...(oldData.fields || {}),
                ...newFields,
              },
            }),
          };
        })
      );

      setAlreadySaved(true);
      setIsEditing(false);
    }

    if (saveError) {
      const msg = saveError?.data?.message || saveError?.error || "Save failed";
      toast.dismiss();
      toast.error(msg, { id: "saveExtractDataError" });
    }
  }, [saveData, saveError]);

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "";

    let parsed;

    // detect format using simple regex
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      // YYYY-MM-DD
      parsed = dayjs(dateString, 'YYYY-MM-DD', true);
    } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      // DD-MM-YYYY
      parsed = dayjs(dateString, 'DD-MM-YYYY', true);
    } else {
      return "Invalid Date";
    }

    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : "Invalid Date";
  };

  const approveFromModal = async () => {
    if (!selectedRow) return;
    if(!invoiceNumberRef.current?.value?.trim())
    {
      alert("Please enter invoice number")
      return;
    }
    const amount = (approveAmountRef.current?.value || "").trim();
    if (!/^\d+(\.\d+)?$/.test(amount)) {
      alert("❌ Please enter a valid purchase amount");
      return;
    }
    if (showExtraction && !alreadySaved) {
      try { await handleSaveExtract(); } catch (_) { }
    }
    handleAcceptRequest({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        order_line_id: selectedRow.order_line_id,
        status: "1",
        purchase_amount: Number(amount),
        invoice_number: invoiceNumberRef.current?.value?.trim(),
      },
    });

  };

  const rejectFromModal = () => {
    if (!selectedRow) return;
    const reason =  rejectReason=="Others" ? (rejectReasonRef.current?.value || "").trim() : rejectReason
    if (!reason) {
      alert("❌ Please enter a reason");
      return;
    }
    handleRejectRequest({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        order_line_id: selectedRow.order_line_id,
        status: "2",
        remark: reason,
      },
    });
  };

  // Bulk Approve (uses selectedRows) - toggle and select all helpers
  const toggleRowSelection = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  // Select all currently visible (in current activeCategory)
  const selectAllVisible = () => {
    const visibleRows = tableDataItems.filter((o) =>
      activeCategory === "all" ? true : o.category === activeCategory
    );

    const ids = visibleRows.filter((r) => !["1", "2"].includes(r.status)).map((r) => r.id);
    const allSelected = ids.every((id) => selectedRows.includes(id));
    if (allSelected) {
      setSelectedRows((prev) => prev.filter((id) => !ids.includes(id)));
    } else {
      setSelectedRows((prev) => Array.from(new Set([...prev, ...ids])));
    }
  };

  const selectAllOnPage = (visibleRows) => {
    const ids = visibleRows
      .filter((r) => r.status !== "1" && r.status !== "2")
      .map((r) => r.id);
    const allSelected = ids.every((id) => selectedRows.includes(id));
    if (allSelected) {
      setSelectedRows((prev) => prev.filter((id) => !ids.includes(id)));
    } else {
      setSelectedRows((prev) => Array.from(new Set([...prev, ...ids])));
    }
  };

  const handleConfirmBulkApprove = () => {
    setShowConfirmModal(true);
  };

  const handleBulkApprove = async () => {
    const rowsToApprove = tableDataItems.filter((r) =>
      selectedRows.includes(r.id)
    );
    setShowConfirmModal(false);
    if (!rowsToApprove.length) return;

    for (const row of rowsToApprove) {
      try {
        const raw = row?.extract_data;
        const extract = raw && typeof raw === "string" ? JSON.parse(raw) : raw || {};
        const purchase_amount =
          (extract?.fields && (extract.fields.total_amount || extract.fields.total_price || extract.fields.amount)) ||
          (extract?.total_amount) ||
          0;

        const invoice_number =
          (extract?.fields && extract.fields.invoice_number) ||
          extract?.invoice_number ||
          "";
        await handleAcceptRequest({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: {
            order_line_id: row.order_line_id,
            status: "1",
            purchase_amount: Number(purchase_amount || 0),
            invoice_number,
          },
        });
      } catch (err) {
        console.error("Bulk approve failed for", row.id, err);
      }
    }
    toast.success(`Approved ${rowsToApprove.length} invoices`);
    setSelectedRows([]);
    handleBikajiOrdersList();
  };

  const columns = [
    {
      name: (
        <input
          type="checkbox"
          onChange={() =>
            selectAllOnPage(
              tableDataItems.filter((o) => o.category === activeCategory || activeCategory === "all")
            )
          }
          checked={
            tableDataItems
              .filter((o) => (activeCategory === "all" ? true : o.category === activeCategory) && !["1", "2"].includes(o.status))
              .length > 0 &&
            tableDataItems
              .filter((o) => (activeCategory === "all" ? true : o.category === activeCategory) && !["1", "2"].includes(o.status))
              .every((r) => selectedRows.includes(r.id))
          }
        />
      ),
      width: "60px",
      cell: (row) => (
        <input
          type="checkbox"
          disabled={["1", "2"].includes(row.status)}
          checked={selectedRows.includes(row.id)}
          onChange={() => toggleRowSelection(row.id)}
        />
      ),
    },
    {
      name: "S.No",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.buyer_name,
      sortable: true,
    },
    {
      name: "Mobile  ",
      selector: (row) => row.buyer_mobile,
    },
    {
      name: "User Type",
      selector: (row) => row.buyer_user_type,
    },
    {
      name: "Purchase Amount",
      selector: (row) => row.purchase_amount,
    },
    {
      name: "Points",
      selector: (row) => row.points,
    },
    {
      name: "Remarks",
      selector: (row) => row.status == "1" ? "Approved" : row.status == "2" ? row.remark : "",
      sortable: true,
    },
    {
      name: "State",
      selector: (row) => row.buyer_state,
    },
    {
      name: "District",
      selector: (row) => row.buyer_district,
    },
    {
      name: "city",
      selector: (row) => row.buyer_city,
    },
    {
      name: "Image / PDF",
      width: "150px",
      cell: (row) => {
        const url = getMediaUrl(row);
        if (!url) return <></>;
        return (
          <>
            <button type="button" className="bg-black p-1 rounded-sm">
              <img src={view} alt="" onClick={() => handleOpenMedia(row)} />
            </button>
          </>
        );
      },
    },
    {
      name: "Request Created At",
      selector: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
      width: "170px",
    },
    {
      name: "Action Taken At",
      selector: (row) =>
        ["1", "2"].includes(row.status)
          ? new Date(row.line_updated_at).toLocaleString()
          : "",
      sortable: true,
      width: "170px",
    },
    {
      name: "Category",
      cell: (row) => (
        <div>
          <span className={`px-2 py-1 rounded text-xs font-semibold ${
            row.category === "green"
              ? "bg-green-200 text-green-800"
              : row.category === "yellow"
              ? "bg-yellow-200 text-yellow-800"
              : "bg-red-200 text-red-800"
          }`}>
            {row.category?.toUpperCase() || "UNKNOWN"}
          </span>
        </div>
      ),
      width: "120px",
    },

    {
      name: "",
      cell: (row) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => openDetailModal(row)}
            className="flex justify-center items-center rounded bg-blue-600 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white hover:bg-blue-700"
          >
            View
          </button>
          {row.status == "2" && <div className="text-red-950">Rejected</div>}
          {row.status == "1" && <div className="text-green-600">Approved</div>}
        </div>
      ),
      width: "250px",
    },
  ];
  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  const filteredData = tableDataItems.filter((o) => (activeCategory === "all" ? true : o.category === activeCategory));

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            <div className="flex items-center justify-between">
              <div>Order Requests List</div>
              <LinksComponent />
            </div>
          </div>

          <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
            <div className="flex justify-between items-start">
              <div className="flex items-center gap-3">
                {/* Master Select All checkbox placed before the tabs (left) */}
                <div className="flex items-center mr-3">
                  <input
                    type="checkbox"
                    onChange={selectAllVisible}
                    checked={
                      tableDataItems
                        .filter((o) => (activeCategory === "all" ? true : o.category === activeCategory) && !["1","2"].includes(o.status))
                        .length > 0 &&
                      tableDataItems
                        .filter((o) => (activeCategory === "all" ? true : o.category === activeCategory) && !["1","2"].includes(o.status))
                        .every((r) => selectedRows.includes(r.id))
                    }
                    title="Select all visible (excluding approved/rejected)"
                  />
                </div>

                {/* Tabs (All, Green, Yellow, Red) */}
                <div className="flex gap-2">
                  {["all", "green", "yellow", "red"].map((c) => (
                    <button
                      key={c}
                      onClick={() => setActiveCategory(c)}
                      className={`px-3 py-1.5 rounded text-sm font-medium capitalize ${
                        activeCategory === c
                          ? c === "green"
                            ? "bg-green-600 text-white"
                            : c === "yellow"
                            ? "bg-yellow-500 text-white"
                            : c === "red"
                            ? "bg-red-600 text-white"
                            : "bg-gray-800 text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                    >
                      {c} ({tableDataItems.filter((o) => (c === "all" ? true : o.category === c)).length})
                    </button>
                  ))}
                </div>
              </div>

              {/* Right side: CSV export + Approve Selected */}
              <div className="mb-2 flex items-center gap-2">
                <CustomExport
                  fetchData={() => {
                    handleBikajiOrdersListCSV();
                  }}
                  data={csvData}
                  defaultColumnExport={[]}
                  filename="cash_transfer_request_list"
                />

                {/* Approve Selected now shows on any tab when selection exists */}
                {selectedRows.length > 0 && (
                  <button
                    onClick={handleConfirmBulkApprove}
                    className="rounded bg-green-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-green-700 disabled:opacity-60"
                  >
                    Approve Selected ({selectedRows.length})
                  </button>
                )}
              </div>
            </div>

            <div className="flex  space-x-2 ">
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Mobile No
                  </label>
                  <input
                    type="search"
                    id="default-search"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Mobile..."
                    required
                    value={request.mobile}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return { ...prevState, mobile: newValue };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    id="default-search"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Start Date"
                    value={request.startDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          startDate: newValue,
                        };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="w-52 ">
                <div className="relative searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    id="default-search"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="End Date"
                    value={request.endDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          endDate: newValue,
                        };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="">
                <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                  &nbsp;
                </label>

                <div className="flex flex-row  gap-2 ">
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleBikajiOrdersList();
                      }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="relative searchin">
                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3">
            {fetchAllBikajiOrdersisLoading && <CircleLoaderComponent />}
            <div className="p-3 w-full bg-white shadow rounded-lg">

              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={filteredData}
                totalRows={
                  fetchAllBikajiOrdersData &&
                  fetchAllBikajiOrdersData?.body?.total_orders
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>

          {showMedia && (
            <MediaModal
              show={showMedia}
              setShow={setShowMedia}
              size="lg"
              url={mediaUrl}
            />
          )}

          {/* ===== Detail Modal (View) ===== */}
          {showDetailModal && selectedRow && (
            <ModalComponent
              size={"6xl"}
              data={selectedRow}
              show={showDetailModal}
              setShow={setShowDetailModal}
            >
              <div className="w-full p-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {/* LEFT: Original Invoice */}
                  <div className="bg-white border rounded-lg p-3">
                    <div className="text-sm font-semibold mb-2">
                      Original Invoice
                    </div>
                    <div className={`h-[480px] ${isPdfFile ? "overflow-hidden" : "overflow-auto"} rounded-md bg-gray-50 border`}>
                       {(() => {
                        const url = urlForPreview
                        if (!url) {
                          return (
                            <div className="h-full flex items-center justify-center text-gray-500 text-sm">
                              No invoice preview available
                            </div>
                          );
                        }
                        if (isPdf(url)) {
                          // Scrollable PDF
                          return (
                            <object data={url} type="application/pdf" className="w-full h-[480px]">
                              <iframe title="invoice-pdf" src={url} className="w-full h-[480px]" />
                            </object>
                          );
                        }
                        // Image
                        return (
                          <img
                            src={url}
                            alt="invoice"
                            className="w-full h-full object-contain transition-transform duration-200"
                            style={{
                              transform: `rotate(${imgRotation}deg)`,
                              transformOrigin: "center center",
                            }}
                            onError={(e) => (e.currentTarget.style.display = "none")}
                          />
                        );
                      })()}
                    </div>
                    {/* Download */}
                    <div className="mt-3 flex items-center gap-2">
                      {urlForPreview && (
                        <a
                          href={urlForPreview}
                          target="_blank"
                          download
                          className="inline-flex items-center rounded bg-gray-800 px-3 py-2 text-xs font-medium text-white hover:bg-gray-900"
                        >
                          {isPdfFile ? "Download PDF" : "Download Image"}
                        </a>
                      )}
                      {!isPdfFile && urlForPreview && (
                        <button
                          type="button"
                          onClick={() => setImgRotation((r) => (r + 90) % 360)}
                          className="inline-flex items-center rounded bg-amber-600 px-3 py-2 text-xs font-medium text-white hover:bg-amber-700"
                          title="Rotate 90°"
                        >
                          Rotate
                        </button>
                      )}
                    </div>
                  </div>

                  {/* RIGHT: User details + Invoice details */}
                  <div className="flex flex-col gap-4">
                    {/* User details (read-only) */}
                    <div className="bg-white border rounded-lg p-3">
                      <div className="text-sm font-semibold mb-3">
                        User Details
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                        <div>
                          <div className="text-gray-600">Date of Upload</div>
                          <div className="font-medium">
                            {new Date(selectedRow.created_at).toLocaleString()}
                          </div>
                        </div>
                        <div>
                          <div className="text-gray-600">Name</div>
                          <div className="font-medium">
                            {selectedRow?.buyer_name || "-"}
                          </div>
                        </div>
                        <div>
                          <div className="text-gray-600">Mobile</div>
                          <div className="font-medium">
                            {selectedRow?.buyer_mobile || "-"}
                          </div>
                        </div>
                        <div>
                          <div className="text-gray-600">User Type</div>
                          <div className="font-medium">
                            {selectedRow?.buyer_user_type || "-"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Invoice details */}
                    <div className="bg-white border rounded-lg p-3">
                      <div className="flex items-center justify-between mb-3">
                        <div className="text-sm font-semibold">
                          Invoice Details
                        </div>
                        {/* Simplified Action Buttons */}
                          {!selectedRow.extract_data ? (
                            <button
                              onClick={handleExtract}
                              className="rounded bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-700 disabled:opacity-60"
                              disabled={extractInvoiceFieldsLoading}
                            >
                              {extractInvoiceFieldsLoading ? "Extracting..." : "Extract"}
                            </button>
                          ) : (
                            <button
                              onClick={() => setIsEditing(true)}
                              className="rounded bg-amber-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-amber-700"
                            >
                              Edit
                            </button>
                          )}
                      </div>

                      {/* Category badge (Green/Yellow/Red) */}
                      {showExtraction && extracted?.category && (
                        <div className="mb-3">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold ${
                              extracted.category === "green"
                                ? "bg-green-200 text-green-800"
                                : extracted.category === "yellow"
                                ? "bg-yellow-200 text-yellow-800"
                                : "bg-red-200 text-red-800"
                            }`}
                          >
                            {extracted.category.toUpperCase()} CATEGORY
                          </span>
                        </div>
                      )}

                      {/* Show editable fields only after extraction */}
                      {showExtraction && (
                        <>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {/* Invoice Date */}
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">
                                Invoice Date
                              </label>
                              <input
                                ref={invoiceDateRef}
                                value={
                                  isEditing
                                    ? extracted?.invoice_date || ""
                                    : dayjs(extracted?.invoice_date,'DD-MM-YYYY').format("DD-MM-YYYY")
                                    ? formatDisplayDate(extracted.invoice_date)
                                    : ""
                                }
                                onChange={(e) =>
                                  isEditing &&
                                  setExtracted((prev) => ({
                                    ...prev,
                                    invoice_date: e.target.value,
                                  }))
                                }
                                readOnly={!isEditing}
                                type={isEditing ? "date" : "text"}
                                className="w-full p-2 text-sm border rounded bg-white"
                                placeholder="DD-MM-YYYY"
                              />
                            </div>

                            {/* Invoice Number */}
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">
                                Invoice Number
                              </label>
                              <input
                                ref={invoiceNumberRef}
                                value={extracted?.invoice_number || ""}
                                onChange={(e) =>
                                  isEditing &&
                                  setExtracted((prev) => ({
                                    ...prev,
                                    invoice_number: e.target.value,
                                  }))
                                }
                                readOnly={!isEditing}
                                type="text"
                                className="w-full p-2 text-sm border rounded bg-white"
                                placeholder="Not found"
                              />
                            </div>

                            {/* GSTIN */}
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">
                                GSTIN
                              </label>
                              <input
                                ref={gstinRef}
                                value={extracted?.gstin || ""}
                                onChange={(e) =>
                                  isEditing &&
                                  setExtracted((prev) => ({
                                    ...prev,
                                    gstin: e.target.value,
                                  }))
                                }
                                readOnly={!isEditing}
                                type="text"
                                className="w-full p-2 text-sm border rounded bg-white"
                                placeholder="Not found"
                              />
                            </div>

                            {/* Total Amount */}
                            <div>
                              <label className="block text-xs text-gray-600 mb-1">
                                Total Amount
                              </label>
                              <input
                                ref={totalAmountRef}
                                value={extracted?.total_amount || ""}
                                onChange={(e) => {
                                  if (isEditing) {
                                    const v = e.target.value.replace(/[^\d.]/g, "");
                                    setExtracted((prev) => ({ ...prev, total_amount: v }));
                                    if (approveAmountRef.current) {
                                      approveAmountRef.current.value = v;
                                    }
                                  }
                                }}
                                readOnly={!isEditing}
                                type="text"
                                className="w-full p-2 text-sm border rounded bg-white"
                                placeholder="Not found"
                              />
                            </div>
                          </div>

                          {/* Buyer Name */}
                          <div className="md:col-span-2 mt-3">
                            <label className="block text-xs text-gray-600 mb-1">
                              Firm Name
                            </label>
                            <input
                              ref={buyerNameRef}
                              value={extracted?.buyer_name || ""}
                              onChange={(e) =>
                                isEditing &&
                                setExtracted((prev) => ({
                                  ...prev,
                                  buyer_name: e.target.value,
                                }))
                              }
                              readOnly={!isEditing}
                              type="text"
                              className="w-full p-2 text-sm border rounded bg-white"
                              placeholder="Not found"
                            />
                          </div>

                          {/* Save button only when editing */}
                          {isEditing && (
                            <div className="mt-3 flex justify-end">
                              <button
                                onClick={() => {
                                  handleSaveExtract();
                                  setIsEditing(false);
                                }}
                                className="rounded bg-emerald-600 px-4 py-2 text-xs font-medium text-white hover:bg-emerald-700 disabled:opacity-60"
                                disabled={saveLoading}
                              >
                                {saveLoading ? "Saving..." : "Save Changes"}
                              </button>
                            </div>
                          )}
                        </>
                      )}

                      {/* Approve / Reject controls */}
                      {["1", "2"].includes(selectedRow.status) ? (
                        // READ-ONLY summary if already approved/rejected
                        <div className="mt-4 border-t pt-4">
                          {selectedRow.status === "1" ? (
                            <div className="flex flex-wrap items-center gap-4 text-sm">
                              <span className="px-2 py-1 rounded bg-green-100 text-green-800">
                                Approved
                              </span>
                              <div>
                                <span className="text-gray-600">Points: </span>
                                <span className="font-medium">
                                  {selectedRow.points ?? "-"}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="flex flex-wrap items-center gap-4 text-sm">
                              <span className="px-2 py-1 rounded bg-red-100 text-red-800">Rejected</span>

                              <div>
                                <span className="text-gray-600">Remark: </span>
                                <span className="font-medium">{selectedRow.remark || "-"}</span>
                              </div>
                            </div>
                          )}

                        </div>

                      ) : (
                        // Editable controls only when status is pending ("0")
                        <div className="mt-4 flex flex-col gap-6">
                          {/* Inputs Section */}
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Purchase Amount */}
                            <div className="flex flex-col">
                              <label className="text-sm font-medium text-gray-700 mb-2">
                                Purchase Amount <span className="text-gray-500">(for Approve)</span>
                              </label>
                              <input
                                ref={approveAmountRef}
                                type="number"
                                step="0.01"
                                className="w-full rounded-lg border border-gray-300 p-2 text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500 bg-white"
                                placeholder="e.g. 1250.00"
                              />
                            </div>

                            {/* Reject Reason */}
                            <div className="flex flex-col">
                              <label className="text-sm font-medium text-gray-700 mb-2">
                                Reject Reason
                              </label>
                              <select
                                className="w-full rounded-lg border border-gray-300 p-2 text-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 bg-white"
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                              >
                                <option value="">Select Reject Reason</option>
                                {JSON.parse(sessionStorage.getItem("vendorData")).theme
                                  .rejection_reasons?.map((reason, idx) => (
                                    <option key={idx} value={reason}>
                                      {reason}
                                    </option>
                                  ))}
                              </select>

                              {rejectReason === "Others" && (
                                <input
                                  ref={rejectReasonRef}
                                  type="text"
                                  className="mt-3 w-full rounded-lg border border-gray-300 p-2 text-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 bg-white"
                                  placeholder="Reason for rejection"
                                />
                              )}
                            </div>
                          </div>

                          {/* Action Buttons */}
                          <div className="flex flex-col md:flex-row gap-3 justify-end">
                            <button
                              onClick={approveFromModal}
                              className="rounded-lg bg-green-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 transition"
                            >
                              Approve
                            </button>
                            <button
                              onClick={rejectFromModal}
                              className="rounded-lg bg-red-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700 transition"
                            >
                              Reject
                            </button>
                          </div>
                        </div>

                      )}
                    </div>
                  </div>
                </div>
              </div>
            </ModalComponent>
          )}

          {/* ===== Confirmation Modal for Bulk Approve ===== */}
          {showConfirmModal && (
            <ModalComponent
              size={"2xl"}
              show={showConfirmModal}
              setShow={setShowConfirmModal}
            >
              <div className="w-full flex flex-col bg-gray-50 rounded-xl overflow-hidden">
                {/* Modal Header */}
                <div className="bg-slate-900 px-6 py-3 flex items-center justify-between text-white border-b border-slate-700">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center">
                      <FiCheckCircle size={20} className="text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-black uppercase tracking-tight">Bulk Approval Confirmation</h3>
                      <p className="text-xs font-bold text-slate-300 mt-0.5">Review and confirm selected invoices</p>
                    </div>
                  </div>
                </div>

                {/* Modal Body */}
                <div className="p-6 flex flex-col gap-6 bg-white">
                  {/* Summary Card */}
                  <div className="bg-emerald-50/50 rounded-xl border-2 border-emerald-100 p-5 flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                      <FiCheckCircle size={24} className="text-emerald-600" />
                    </div>
                    <div className="flex-1">
                      <h4 className="text-sm font-black text-emerald-800 uppercase tracking-tight">Ready to Approve</h4>
                      <p className="text-xs font-bold text-emerald-700 mt-1">
                        {selectedRows.length} invoice{selectedRows.length !== 1 ? 's' : ''} selected for approval
                      </p>
                    </div>
                  </div>

                  {/* Selected Invoices Section */}
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-between px-1">
                      <h4 className="text-sm font-bold text-gray-700 uppercase tracking-tight flex items-center gap-2">
                        <FiInfo className="text-blue-500" size={16} /> Selected Invoices ({selectedRows.length})
                      </h4>
                    </div>
                    <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 max-h-64 overflow-y-auto custom-scrollbar">
                      <div className="space-y-2">
                        {tableDataItems
                          .filter((r) => selectedRows.includes(r.id))
                          .map((row) => {
                            const raw = row?.extract_data;
                            const extract = raw && typeof raw === "string" ? JSON.parse(raw) : raw || {};
                            const amount = (extract?.fields?.total_amount || extract?.total_amount || 0);
                            return (
                              <div key={row.id} className="flex items-center justify-between p-3 rounded-lg bg-white border border-gray-100 border-l-2 border-l-emerald-400 hover:shadow-sm transition-all">
                                <div className="flex flex-col min-w-0 flex-1">
                                  <span className="text-xs font-black text-gray-800 uppercase tracking-tight">Invoice #{row.id}</span>
                                  <span className="text-[11px] font-bold text-gray-500 mt-0.5">{row.buyer_name}</span>
                                </div>
                                <div className="flex items-center gap-4 shrink-0">
                                  <div className="flex flex-col items-end">
                                    <span className="text-xs font-black text-emerald-600">₹{Number(amount || 0).toFixed(2)}</span>
                                    <span className="text-[9px] font-bold text-gray-400 uppercase">Amount</span>
                                  </div>
                                  <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                                    <FiCheckCircle size={14} className="text-emerald-600" />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  {/* Info Alert */}
                  <div className="bg-blue-50/50 rounded-xl border-l-4 border-blue-500 p-4 flex gap-3">
                    <FiInfo className="text-blue-500 shrink-0 mt-0.5" size={18} />
                    <div className="flex flex-col gap-1">
                      <p className="text-xs font-black text-blue-800 uppercase tracking-tight">Automatic Processing</p>
                      <p className="text-xs text-blue-700 font-semibold">The system will use extracted invoice amounts. If an amount is missing or zero, manual review will be required.</p>
                    </div>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex items-center gap-3 justify-end">
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="rounded-lg bg-gray-300 text-gray-800 px-5 py-2.5 text-xs font-bold uppercase tracking-wider hover:bg-gray-400 transition shadow-sm active:scale-95"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleBulkApprove}
                    className="rounded-lg bg-emerald-600 text-white px-5 py-2.5 text-xs font-bold uppercase tracking-wider hover:bg-emerald-700 transition shadow-lg shadow-emerald-600/30 active:scale-95"
                  >
                    ✓ Confirm & Approve
                  </button>
                </div>
              </div>
            </ModalComponent>
          )}
        </div>
      </div>
    </>
  );
};

export default BikajiOrderList;